import React from 'react';
import { Switch as BaseSwitch } from 'react-router-dom';
import { flattenChildren } from '../../../utils';
import { Props } from './flat-switch-type';

export const Switch: React.FC<Props> = ({ children }: Props) => <BaseSwitch>{flattenChildren(children)}</BaseSwitch>;
